/**
 * Where Project ORCHARD lives.
 *
 * A different origin since the split, so links to it are absolute and cannot
 * go through the router. Kept here rather than inline so moving the game again
 * is one edit.
 */
export const ORCHARD_URL = "https://orchard.paulie.app";
